import { Snackbar } from "src/app/shared/types/snackbar";

export const snackbarCopyCode: Snackbar = {
    duration: 2000,
    message: 'copy_code.copy_message',
    horizontalPosition: 'center',
    verticalPosition: 'top',
    type: 'pending-snackbar',
  };